// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".no-padding-label label {\n  padding: 0 !important;\n}\n.no-padding-label label .q-field__inner {\n  padding-bottom: 0 !important;\n}", ""]);
// Exports
module.exports = exports;
